// extracted by mini-css-extract-plugin
export default {"hovered":"logo_hovered__88Afl","bw_circle":"logo_bw_circle__oGwgt","bw_stars":"logo_bw_stars__nOlKq","stars":"logo_stars__rNj8n"};